export enum CommentsAndProofingDocTypeEnum {
    file = "file",
    collection = "collection",
    project = "project",
}
